<template>

	<div class="no-gutters text-center pb-3">
			<span property="itemListElement" typeof="ListItem">
				<a property="item" typeof="WebPage" title="Go to EveryLink." href="/" class="home">
					<span property="name">EveryLink</span>
				</a>
				<meta property="position" content="1">
			</span>
		<span property="itemListElement" typeof="ListItem">
				<span class="d"> &gt; </span>
				<a property="item" typeof="WebPage" title="Go to EveryLink." href="/people" class="home">
					<span property="name">People</span>
				</a>
				<meta property="position" content="1">
			</span>
		<span property="itemListElement" typeof="ListItem">
						<span class="d"> &gt; </span>
						<Skeletor class="d-inline-block" v-if="isLoading" width="140" height="15" />
						<span v-else property="name">Post > {{ getAuthorFullName }}</span>
						<meta property="position" content="3">
					</span>
	</div>

	<div class="link-content mb-5">
		<div v-if="post?.metaInput" class="row">
			<div class="col-12">
				<div class="mb-5 d-flex align-items-center justify-content-between">
					<router-link :to="`/person/?id=${post?.author.wpId}`" class="d-flex align-items-center">
						<div class="avatar avatar--mini flex-shrink-0 me-1" :style="{ backgroundImage: `url(${post?.author.avatar})` }"></div>
						<p class="mb-0">{{ getAuthorFullName }}</p>
					</router-link>
					<div class="d-flex align-items-center gap-3">
						<div>{{ getFormatDatePost }}</div>
						<button @click="deletePost" v-if="currentUser.wpId === post?.author.wpId" class="btn btn-sm btn-danger">Delete Post</button>
					</div>
				</div>
			</div>

			<div v-if="post?.authorContent" class="col-12">
				<p>{{ post?.authorContent }}</p>
			</div>

			<div class="col-12 col-lg">
				<iframe v-if="post?.metaInput?.sourceUrl && getYouTubeId" width="560" height="315"
						:src="`https://www.youtube.com/embed/${getYouTubeId}`"
						frameborder="0"
						allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
						allowfullscreen></iframe>
				<img v-else :src="post.metaInput.image" alt="" class="d-block w-100 mb-4">
			</div>

			<div class="col-12 col-lg">
				<h1>{{ post?.title }}</h1>

				<p>{{ post?.description }}</p>

				<div class="text-left">
					<a :href="post?.metaInput.sourceUrl" class="btn btn-lg btn-primary" target="_blank">
						Open link
					</a>
				</div>
			</div>
		</div>
		<div v-else class="row">
			<div class="col-12">
				<div class="mb-5 d-flex align-items-center justify-content-between">
					<Skeletor class="d-inline-block" v-if="isLoading" width="140" height="15" />
					<router-link v-else :to="`/person/?id=${post?.author.wpId}`" class="d-flex align-items-center">
						<div class="avatar avatar--mini flex-shrink-0 me-1" :style="{ backgroundImage: `url(${post?.author.avatar})` }"></div>
						<p class="mb-0">{{ getAuthorFullName }}</p>
					</router-link>
					<Skeletor class="d-inline-block" v-if="isLoading" width="140" height="15" />
					<div v-else class="d-flex align-items-center gap-3">
						<div>{{ getFormatDatePost }}</div>
						<button @click="deletePost" v-if="currentUser?.wpId === post?.author?.wpId" class="btn btn-sm btn-danger">Delete Post</button>
					</div>
				</div>
			</div>
			<div class="col-12 col-lg">
				<Skeletor class="d-inline-block" v-if="isLoading" width="560" height="315" />
				<img v-else :src="post?.image" alt="" class="d-block w-100 mb-4">
			</div>

			<div class="col-12 col-lg">
				<Skeletor class="mb-3" v-if="isLoading" width="360" height="20" />
				<Skeletor class="mb-3" v-if="isLoading" width="160" height="20" />
				<Skeletor class="mb-3" v-if="isLoading" width="60" height="30" pill />
			</div>
			<div class="col-12">
				<p>{{ post?.authorContent }}</p>
			</div>
		</div>
	</div>

	<div class="comments-area">

		<h4 v-if="post?.metaInput" class="comments-title">{{ post?.comments.length }} comments on “<span>{{ post?.title
			}}</span>”</h4>
		<h4 v-else>{{ post?.comments.length }} comments</h4>

		<ol class="comment-list" v-if="isLoading">
			<Skeletor class="mb-3" width="100%" height="50" pill />
			<Skeletor class="mb-3" width="100%" height="50" pill />
			<Skeletor class="mb-3" width="100%" height="50" pill />
		</ol>
		<ol v-else class="comment-list">
			<div v-for="comment of post?.comments" :key="comment?._id" class="custom-comment-holder">
				<div class="custom-comment">
					<div class="author">
						<router-link
							:to="currentUser?.wpId === comment.user.wpId ? '/' : `/person/?id=${comment.user.wpId}`"
							class="d-flex align-items-center">
							<div class="avatar avatar--mini flex-shrink-0 me-3" :style="{ backgroundImage: `url(${comment?.user.avatar})` }"></div>
							<p class="mb-0">{{ comment?.user.firstName }} {{ comment?.user.lastName }}</p>
						</router-link>
					</div>
					<div class="comment-content py-2 ps-5">{{ comment.text }}</div>
				</div>
				<div class="reply-and-time">
					<!--					<a href='/' class="comment-reply-link">Reply</a>-->
					<span class="time">{{ formatCommentDate(comment.created_at) }}</span>
				</div>
			</div>
			<!--			<ul class="children">-->
			<!--				<div class="custom-comment-holder">-->
			<!--					<div class="custom-comment">-->
			<!--						<span class="author">Rad</span>-->
			<!--						<span class="comment-content">Reply 1</span>-->
			<!--					</div>-->

			<!--					<div class="reply-and-time">-->
			<!--						<a href='/' class="comment-reply-link">Reply</a>-->
			<!--						<span class="time">time</span>-->
			<!--					</div>-->
			<!--				</div>-->
			<!--			</ul>-->
		</ol>

		<div class="comment-respond">
			<h3 id="reply-title" class="comment-reply-title">Leave a Reply</h3>
			<form @submit.prevent="addComment" class="comment-form">
				<p class="logged-in-as">Logged in as {{ currentUser?.email }}
					<a href="/profile-edit">Edit your profile</a>.
					<span class="required-field-message">Required fields are marked
						<span class="required">*</span>
					</span>
				</p>
				<p class="comment-form-comment">
					<label for="comment">Comment<span class="required">*</span></label>
					<textarea v-model="commentValue" id="comment" name="comment" cols="45" rows="8" maxlength="65525" required=""></textarea>
				</p>
				<button class="btn btn-lg btn-primary" type="submit">Post Comment</button>
			</form>
		</div>
	</div>

</template>

<script lang="ts">
/* eslint-disable */
import { defineComponent } from 'vue'
import extractYouTubeVideoId from '@/utils/extractYouTubeVideoId';
import axios from 'axios';
import formatDate from '@/utils/formatDate';

interface IUser {
	_id?: number
	wpId: number
	firstName: string
	lastName: string
	email: string
	friendRequests?: object[]
	friends?: object[]
	avatar?: string
	posts?: object[]
}

interface IPost {
	_id: number,
	author: {
		_id: number,
		wpId: number,
		avatar: string
		firstName: string,
		lastName: string
	}
	title?: string
	description?: string
	authorContent?: string,
	metaInput?: {
		image: string,
		sourceUrl: string
	}
	comments?: [],
	created_at: string
	image?: string
}

export default defineComponent({
	name: 'PersonView',
	data(){
		return {
			isLoading: false,
			wpUser: null as IUser | null,
			currentUser: null as IUser | null,
			post: null as IPost | null,
			commentValue: ''
		};
	},
	computed: {
		getYouTubeId(){
			return extractYouTubeVideoId(this.post?.metaInput?.sourceUrl)
		},
		getAuthorFullName(){
			return this.post?.author?.firstName + ' ' + this.post?.author?.lastName
		},
		getFormatDatePost(){
			return formatDate(this.post?.created_at)
		}
	},
	async mounted(){
		this.isLoading = true
		await this.getUserFromWp()
		await this.getUser()
		await this.getPost()
		this.isLoading = false
	},
	methods: {
		formatCommentDate(date: string){
			return formatDate(date)
		},
		async getUserFromWp(){
			try {
				const res = await axios.get('/api/get_current_user.php')
				this.wpUser = res.data
			} catch (err){
				console.log(err)
			}
		},
		async getUser(){
			try {
				const res = await axios.get(`${process.env.VUE_APP_BASE_API_URI}/users/${this.wpUser?.wpId}`)
				this.currentUser = res.data
			} catch (err){
				console.log(err)
			}
		},

		async getPost(){
			try {
				const res = await axios.get(`${process.env.VUE_APP_BASE_API_URI}/posts/${this.$route.query.id}`)
				this.post = res.data
			} catch (err){
				console.log(err)
			}
		},
		async addComment(){
			try {
				await axios.put(`${process.env.VUE_APP_BASE_API_URI}/posts/${this.$route.query.id}/comment`, {
					text: this.commentValue,
					user: this.currentUser?._id
				})
				this.commentValue = ''
				await this.getPost()
			} catch (err){
				console.log(err)
			}
		},
		async deletePost(){
			try {
				await axios.delete(`${process.env.VUE_APP_BASE_API_URI}/posts/${this.$route.query.id}`)
				this.$router.push('/')
			} catch (err){
				console.log(err)
			}
		}
	},
})
</script>

<style scoped>

</style>
